import { inject, Injectable } from '@angular/core';
import {
	ClaimStatusesClient,
	LeadStatusesClient,
	PagedDataDtoOfClaimStatusListDto,
	PagedDataDtoOfLeadStatusListDto,
	PagedRequestDto,
} from './api.service';
import { LeadStatusesStore } from 'app/store/lead-status.store';
import { ClaimStatusesStore } from 'app/store/claim-status.store';
import { combineLatest, Observable, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class InitAppService {
	private readonly _claimStatusesClient = inject(ClaimStatusesClient);
	private readonly _leadStatusesClient = inject(LeadStatusesClient);

	private readonly _claimStatusesStore = inject(ClaimStatusesStore);
	private readonly _leadStatusesStore = inject(LeadStatusesStore);

	constructor() {}

	init(): Observable<
		[PagedDataDtoOfClaimStatusListDto, PagedDataDtoOfLeadStatusListDto]
	> {
		const dto = PagedRequestDto.fromJS({
			pageSize: 25,
			page: 0,
			sort: 'order',
			sortDirection: 'asc',
		});

		return combineLatest([
			this._claimStatusesClient.getList(dto),
			this._leadStatusesClient.getList(dto),
		]).pipe(
			tap(
				([claimStatuses, leadStatuses]: [
					PagedDataDtoOfClaimStatusListDto,
					PagedDataDtoOfLeadStatusListDto
				]) => {
					this._claimStatusesStore.initializeClaimStatuses(
						claimStatuses?.records ?? []
					);
					this._leadStatusesStore.initializeLeadStatuses(
						leadStatuses?.records ?? []
					);
				}
			)
		);
	}
}
